// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__ajC-I","tab":"ProcedureTabs_tab__3ukU3"};